"use client";

import { clsx } from "clsx";
import type { ReactNode } from "react";

type Props = {
  selected: boolean;
  onSelect: () => void;
  children: ReactNode;
  disabled?: boolean;
};

export function OptionPill({ selected, onSelect, children, disabled }: Props) {
  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={disabled}
      aria-pressed={selected}
      className={clsx(
        "inline-flex items-center justify-center px-6 py-1.5 rounded-full text-base font-semibold transition-colors",
        "focus-ring",
        "cursor-pointer disabled:cursor-not-allowed disabled:pointer-events-none disabled:opacity-50",
        selected
          ? "bg-primary text-text-inverse border-2 border-primary"
          : "bg-surface text-text border-2 border-border-strong hover:border-primary hover:text-primary",
      )}
    >
      {children}
    </button>
  );
}
